
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import PropositionForm from '@/components/forms/PropositionForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const propositionModule = namespace('proposition')
const refModule = namespace('ref')
const uiModule = namespace('ui')

@Component({
  components: {
    BaseCardContainer,
    PropositionForm
  }
})
export default class ProspectPropositionCreate extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @propositionModule.Action('createPropositionAction') createProposition: any
  @refModule.Getter('refGetter') refObject: any
  @refModule.Action('getRefAction') getRef: any
  @uiModule.Action('resetIsEditAction') resetIsEdit: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  mounted() {
    if (!this.refObject.offre) {
      this.getRef('offre')
    }
    if (!this.refObject.typeRemise) {
      this.getRef('typeRemise')
    }
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createProposition(data).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.resetIsEdit()
      this.$router.push({name: 'prospectProposition', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.replace({name: 'prospectProposition', params: {id: this.$route.params.id}})
  }
}
